// React Dependencies
import React from 'react';

// External Dependencies
import { Bar, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import PropTypes from 'prop-types';

// Internal Dependencies
import Colours from '../../../../styles/colours';
import MText from '../../../../components/Common/MText';
import { IsEmpty } from '../../../../common/checks';

const ResponsiveChart = (props) => (
  <div>
    <div
      className="overflow-auto"
      style={{
        marginLeft: -44,
      }}
    >
      <ResponsiveContainer
        width="100%"
        minWidth={600}
        height={400}
      >
        <ComposedChart
          data={props.data}
          margin={{ top: 30, bottom: 20 }}
          barGap={0}
        >
          <XAxis
            stroke={Colours.LightGray}
            strokeWidth={2}
            dataKey={props.xAxisDataKey}
            tick={{ fill: Colours.Black, fontSize: '.7rem' }}
            tickMargin={8}
            label={{
              fill:     Colours.Black,
              fontSize: '.7rem',
              value:    'Date',
              offset:   0,
              position: 'outside-bottom',
              dy:       20,
            }}
          />
          <YAxis
            stroke={Colours.LightGray}
            strokeWidth={2}
            tick={false}
            label={{
              fill:     Colours.Black,
              fontSize: '.7rem',
              value:    'Count',
              angle:    -90,
            }}
          />
          {
            !IsEmpty(props.outletsKey) ? props.outletsKey.map((o) => (
              <Bar
                dataKey={o.key}
                fill={o.colour}
                label={{ position: 'top', fontSize: '.5rem', offset: 10, fill: Colours.Black }}
              />
            )) : (
              <Bar dataKey="total" label={{ position: 'top', fontSize: '.5rem', offset: 10, fill: Colours.Black }} />
            )
          }
          {
            !IsEmpty(props.outletsKey) && (
              <Line
                type="linear"
                dataKey={props.totalDataKey}
                stroke="#b3b3b3"
                strokeWidth={4}
                dot={{ r: 8, fill: '#0e99ff', stroke: 'rgba(255,255,255,1)', strokeWidth: 2 }}
                label={{ position: 'top', fontSize: '.5rem', offset: 20, fill: Colours.Black }}
              />
            )
          }
          <Tooltip />
        </ComposedChart>
      </ResponsiveContainer>
    </div>

    <div
      className="d-flex flex-column"
      style={{
        rowGap: 4,
      }}
    >
      {
        props.outletsKey.map((outlet) => (
          <div
            key={outlet.key}
            className="d-flex flex-row"
            style={{
              columnGap: 4,
            }}
          >
            <div style={{
              width:           48,
              height:          20,
              backgroundColor: outlet.colour,
              borderRadius:    2,
            }}
            />
            <MText size=".8rem" text={outlet.key} />
          </div>
        ))
      }
    </div>
  </div>
);

ResponsiveChart.propTypes = {
  data:       PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  outletsKey: PropTypes.arrayOf(
    PropTypes.shape({
      key:    PropTypes.string.isRequired,
      colour: PropTypes.string.isRequired,
    }),
  ).isRequired,
  xAxisDataKey: PropTypes.string.isRequired,
  totalDataKey: PropTypes.string,
};

ResponsiveChart.defaultProps = {
  totalDataKey: 'total',
};

export default ResponsiveChart;
